import React, { useCallback, useEffect, useMemo } from 'react'
import PropTypes from 'prop-types'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import { useVariables } from '../../../../providers/VariableProvider'
import DateTimePicker from './StyledPicker'
dayjs.extend(utc)

export const useDefaultAsOfDate = () => {
  return useMemo(() => {
    return dayjs.utc().add(-1, 'day').startOf('day').format('YYYY-MM-DD')
  }, [])
}

function PipelineDatePicker ({ applyTo, format, disableFuture, disabled, style, className }) {
  const defaultDate = useDefaultAsOfDate()
  const { setVariable, getVariable } = useVariables()
  const setDate = useCallback((date) => {
    const parsed = dayjs.utc(date).format('YYYY-MM-DD')
    setVariable(applyTo, parsed)
  }, [setVariable, applyTo])

  // This sets the default variable value. Open to other ways to do this.
  useEffect(() => {
    if (getVariable(applyTo) === undefined) {
      setVariable(applyTo, defaultDate)
    }
  }, [setVariable, getVariable, applyTo, defaultDate])

  return (
    <DateTimePicker
      type='date'
      format={format}
      disableFuture={disableFuture}
      onChange={setDate}
      extraStyles={style}
      className={className}
      value={getVariable(applyTo, defaultDate)}
      disabled={disabled}
    />
  )
}

PipelineDatePicker.propTypes = {
  applyTo: PropTypes.string,
  format: PropTypes.string,
  disableFuture: PropTypes.bool,
  disabled: PropTypes.bool,
  style: PropTypes.object,
  className: PropTypes.string
}

PipelineDatePicker.defaultProps = {
  applyTo: 'asOfDate',
  format: '[As of] MMMM DD, YYYY',
  disableFuture: true,
  disabled: false
}

export default PipelineDatePicker
